export default __webpack_public_path__ + "static/media/loss-setup-step4.ef42cb80.gif";